import { apiRequest } from './api';

export const SocialService = {
    /**
     * GET /users/search?q=
     * Returns: [{ id, username, display_name, avatar_url, coin_count }]
     */
    async searchUsers(query) {
        const encoded = encodeURIComponent(query.trim());
        return apiRequest(`/users/search?q=${encoded}`);
    },

    async checkUsernameAvailability(username) {
        const encoded = encodeURIComponent(username.trim().toLowerCase());
        return apiRequest(`/users/username-availability?username=${encoded}`, {
            authenticated: false,
        });
    },

    /**
     * GET /users
     * Returns a default browse list of public users with coin counts.
     */
    async getUsers() {
        return apiRequest('/users');
    },

    async getPublicProfile(username) {
        return apiRequest(`/users/${encodeURIComponent(username)}`);
    },

    async follow(userId) {
        return apiRequest(`/users/${userId}/follow`, { method: 'POST' });
    },

    async unfollow(userId) {
        return apiRequest(`/users/${userId}/follow`, { method: 'DELETE' });
    },

    async getFollowStatus(userId) {
        return apiRequest(`/follows/${userId}/status`);
    },

    async getFollowers(userId) {
        return apiRequest(`/users/${userId}/followers`);
    },

    async getFollowing(userId) {
        return apiRequest(`/users/${userId}/following`);
    },
};
